(function () {
  'use strict';
  if (window.__csMimiInit) return;
  window.__csMimiInit = true;

  /* ============ Driver d'humeur exposé globalement ============ */
  window.__csMimi = window.__csMimi || {};
  window.__csMimi._moodTimer = null;
  window.__csMimi.setMood = function (mood, durationMs) {
    var el = document.querySelector('[data-cs-mimi]');
    if (!el) return;
    el.setAttribute('data-mood', mood);
    if (window.__csMimi._moodTimer) {
      clearTimeout(window.__csMimi._moodTimer);
      window.__csMimi._moodTimer = null;
    }
    if (durationMs && mood !== 'idle' && mood !== 'pensive' && mood !== 'endormie') {
      window.__csMimi._moodTimer = setTimeout(function () {
        el.setAttribute('data-mood', 'idle');
      }, durationMs);
    }
  };

  /* Lazy init (TBT optim 2026-05-10) : on diffère le gros init (30+ querys,
     listeners panel, tabs, form, Smile balance, etc.) au prochain idle ou
     première interaction utilisateur. La mascotte reste cliquable pendant ce
     temps grâce à un click-handler pré-init qui force l'init avant d'ouvrir.
     setMood() public API marche immédiatement (query DOM à l'appel). */
  var mimiInitDone = false;
  var mimiInitPending = false;
  var mainInit = null; // assigné juste après

  function scheduleMimiInit() {
    if (mimiInitDone || mimiInitPending) return;
    mimiInitPending = true;
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function(){ runMimiInit(); }, { timeout: 4000 });
    } else {
      setTimeout(runMimiInit, 1500);
    }
  }
  function runMimiInit() {
    if (mimiInitDone) return;
    mimiInitDone = true;
    if (typeof mainInit === 'function') mainInit();
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Capture le moment "page prête" pour que setupReadingMood mesure le dwell
    // depuis le DOMContentLoaded et non depuis l'init (qui peut tarder en idle).
    window.__csMimiPageReadyAt = Date.now();

    // Pre-init : click sur la mascotte force runMimiInit synchrone si pas encore fait
    var preTrigger = document.querySelector('[data-cs-mimi-trigger]');
    if (preTrigger) {
      preTrigger.addEventListener('click', function preClick(){
        if (!mimiInitDone) runMimiInit();
      }, { capture: true });
    }
    // Schedule init en idle (ou 1ère interaction via scheduleMimiInit déjà)
    scheduleMimiInit();
    // Forcer aussi sur 1ère interaction de la page (scroll, click anywhere, etc.)
    ['scroll', 'pointerdown', 'keydown', 'touchstart'].forEach(function(ev){
      window.addEventListener(ev, scheduleMimiInit, { once: true, passive: true, capture: true });
    });
  });

  mainInit = function () {
    var root = document.querySelector('[data-cs-mimi]');
    if (!root) return;

    var trigger = root.querySelector('[data-cs-mimi-trigger]');
    var panel = root.querySelector('[data-cs-mimi-panel]');
    var closeBtn = root.querySelector('[data-cs-mimi-close]');
    var notif = root.querySelector('.cs-mimi__notif');
    var tabs = root.querySelectorAll('[data-tab]');
    var views = root.querySelectorAll('[data-view]');
    var msgContainer = root.querySelector('[data-cs-mimi-messages]');
    var form = root.querySelector('[data-cs-mimi-form]');
    var input = root.querySelector('[data-cs-mimi-input]');
    var quickActions = root.querySelectorAll('[data-quick]');
    var smileRewardsBtn = root.querySelector('[data-cs-mimi-smile-rewards]');
    var smileReferralBtn = root.querySelector('[data-cs-mimi-smile-referral]');
    var data = window.__csMimiData || {};

    var lastFocusBeforeOpen = null;

    function getFocusables() {
      return panel.querySelectorAll(
        'button:not([disabled]):not([hidden]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
    }

    /* Ferme le panneau Shopify Inbox s'il est ouvert. Le widget utilise
       button.chat-toggle (dans le shadow root du custom element) comme toggle :
       cliquer dessus quand isOpen=true le ferme. On ne clique que si l'état
       courant est "open" pour éviter d'ouvrir Inbox quand Mimi devrait juste s'ouvrir. */
    function closeShopifyInboxIfOpen() {
      try {
        var raw = localStorage.getItem('shopifyChatData');
        if (!raw) return;
        var chatData = JSON.parse(raw);
        if (!chatData || chatData.isOpen !== true) return;
        var ic = document.querySelector('inbox-online-store-chat');
        var btn = null;
        if (ic && ic.shadowRoot) {
          btn = ic.shadowRoot.querySelector('button.chat-toggle, button[class*="chat-toggle"], button[class*="chat-close"], button[aria-label*="close" i]');
        }
        if (!btn) {
          btn = document.querySelector('button.chat-toggle, button[class*="chat-toggle"]');
        }
        if (btn && typeof btn.click === 'function') { btn.click(); return; }
        /* Fallback : flip localStorage + storage event */
        chatData.isOpen = false;
        var newRaw = JSON.stringify(chatData);
        localStorage.setItem('shopifyChatData', newRaw);
        if (typeof StorageEvent === 'function') {
          window.dispatchEvent(new StorageEvent('storage', {
            key: 'shopifyChatData', oldValue: raw, newValue: newRaw, storageArea: localStorage
          }));
        }
      } catch (e) {}
    }

    /* Les boutons externes (« Tu hésites ? » de la home, « Demander à Mimi » du footer, page
       Angoulême, blog…) appellent trigger.click() depuis leur propre clic : ce clic continue ensuite
       jusqu'au document, hors de Mimi, et refermait le panneau aussitôt ouvert (2026-09-28).
       On ignore donc le clic « extérieur » pendant la tâche qui a ouvert le panneau, et on annule
       une fermeture en cours si le panneau est rouvert avant la fin de son animation. */
    var openingTick = false;
    var hideTimer = null;

    function openPanel() {
      /* Si Inbox est ouvert, on le ferme avant d'ouvrir Mimi : Mimi est l'entrée
         principale, donc tap sur la bulle Mimi reprend toujours le focus. */
      closeShopifyInboxIfOpen();
      clearTimeout(hideTimer);
      openingTick = true;
      setTimeout(function () { openingTick = false; }, 0);
      lastFocusBeforeOpen = document.activeElement;
      panel.removeAttribute('hidden');
      requestAnimationFrame(function () {
        panel.classList.add('is-open');
        if (closeBtn && closeBtn.focus) closeBtn.focus();
      });
      trigger.setAttribute('aria-expanded', 'true');
      if (notif) notif.classList.add('is-hidden');
      /* Dismiss product bubble if visible — user engaged with Mimi */
      var bubble = document.querySelector('[data-cs-mimi-bubble]');
      if (bubble) bubble.classList.remove('is-visible');
    }
    function closePanel() {
      panel.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () { panel.setAttribute('hidden', ''); }, 300);
      if (lastFocusBeforeOpen && lastFocusBeforeOpen.focus) {
        try { lastFocusBeforeOpen.focus(); } catch (_) {}
      } else if (trigger && trigger.focus) {
        trigger.focus();
      }
    }
    trigger.addEventListener('click', function () {
      if (panel.hasAttribute('hidden')) openPanel();
      else closePanel();
    });
    closeBtn.addEventListener('click', closePanel);

    document.addEventListener('click', function (e) {
      if (panel.hasAttribute('hidden')) return;
      if (openingTick) return; /* clic qui vient d'ouvrir le panneau via un bouton externe */
      if (root.contains(e.target)) return;
      closePanel();
    });

    /* Esc closes + focus trap */
    panel.addEventListener('keydown', function (e) {
      if (panel.hasAttribute('hidden')) return;
      if (e.key === 'Escape') {
        e.stopPropagation();
        closePanel();
        return;
      }
      if (e.key !== 'Tab') return;
      var focusables = getFocusables();
      if (focusables.length === 0) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-tab');
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-tab') === target;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        views.forEach(function (v) {
          v.classList.toggle('is-active', v.getAttribute('data-view') === target);
        });
      });
    });

    var refusePunchlines = [
      "100 % France, 100 % légal — pas de HHC ici. Mais essaie nos résines 3× filtrées, tu vas comprendre.",
      "On cultive du chanvre, pas des ennuis. Pas de molécules de synthèse chez Cloud Store — que du vrai CBD français.",
      "Ah, le HHC… on laisse ça aux autres. Nos fleurs indoor parlent d'elles-mêmes ",
      "THC > 0,3 % = pas chez nous. On reste 100 % légal, et franchement nos lots premium font le job.",
      "CBD+, H4CBD, HHC… nous on a choisi de rester clean. Du chanvre français, des analyses à chaque lot, et c'est tout."
    ];

    function pickRandom(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

    function parseTopStrong(raw) {
      if (!raw) return [];
      return raw.split('~').filter(Boolean).map(function (entry) {
        var parts = entry.split('|');
        return { handle: parts[0], title: parts[1], url: parts[2], rate: parseFloat(parts[3]) || 0 };
      }).sort(function (a, b) { return b.rate - a.rate; }).slice(0, 3);
    }

    var topStrong = parseTopStrong(data.topStrong);

    var intents = [
      /* ============ 1. Refus HHC / synthétiques (légal critique) ============ */
      {
        match: /\b(hhc|cbd\+|h4cbd|thcp?|mol[ée]cule|synth[ée]tique)\b/i,
        respond: function () { return pickRandom(refusePunchlines); },
        mood: 'maline'
      },

      /* ============ 2. Top puissance (live data) ============ */
      {
        match: /\b(fort|puissant|meilleur cbd|taux fort|fort en cbd|haut taux)\b/i,
        respond: function () {
          if (topStrong.length === 0) {
            return "Côté puissance, regarde nos fleurs indoor hydroponie : <a href=\"/collections/toutes-nos-fleurs\">toutes les fleurs</a>.";
          }
          var html = "Voici nos plus forts en CBD :<br>";
          topStrong.forEach(function (p) {
            html += '<a class="cs-mimi__msg-product" href="' + p.url + '"><span class="cs-mimi__msg-product-name">' + p.title + '</span><span class="cs-mimi__msg-product-meta">' + p.rate + '% CBD</span></a>';
          });
          return html;
        }
      },

      /* ============ 3. Durée d'action (avant livraison qui contient "combien de temps") ============ */
      {
        match: /(dur[ée]e (de l'?effet|d'action)|effet (dure|tient|reste)|combien de temps (dure|tient|fait effet|reste|agit))/i,
        respond: function () {
          return "Ça dépend du format ⏱<br>"
            + "• <b>Sublingual</b> (huile sous la langue) → effet en 15-30 min, dure 4-6 h<br>"
            + "• <b>Inhalation</b> (fleur, vape) → 2-5 min, dure 2-3 h<br>"
            + "• <b>Ingestion</b> (gélule, tisane, alimentaire) → 30-90 min, dure 6-8 h<br>"
            + "Choix du format = quel moment, quel besoin.";
        }
      },

      /* ============ 4. Livraison ============ */
      {
        match: /\b(livraison|exp[ée]dition|d[ée]lai|colis|combien de temps)\b/i,
        respond: function () { return "Expédition sous <b>24 h</b> depuis la Charente, livraison Colissimo <b>offerte dès 50 €</b>. Le colis arrive en 1-3 jours après expédition."; }
      },

      /* ============ 5. Paiement ============ */
      {
        match: /\b(paiement|cb|carte|virement|payer|klarna|sepa|bancontact|s[ée]curis)\b/i,
        respond: function () {
          return "Voici nos moyens de paiement :<br>"
            + "• <b>Carte bancaire</b> — Visa, Mastercard, Maestro, Amex<br>"
            + "• <b>Klarna</b> — paiement en plusieurs fois<br>"
            + "• <b>Bancontact</b> (Belgique)<br>"
            + "• <b>Virement SEPA</b><br>"
            + "Paiement 100 % sécurisé via <b>Viva.com</b> ";
        }
      },

      /* ============ 6. Prix au gramme ============ */
      {
        match: /\b(prix|co[ûu]t|tarif|cher|abordable|prix au gramme)\b|combien (ça|ca) (co[ûu]te|coute)/i,
        respond: function () {
          return "Côté <b>fleurs CBD</b>, on est entre <b>3,50 €/g et 12 €/g</b> selon le lot (outdoor → premium indoor hydroponie). "
            + "<b>Plus tu prends, moins c'est cher au gramme</b> (paliers à 5g, 10g, 25g, 50g). "
            + 'Côté huiles, ça démarre à 24,90 €.<br>'
            + '<a class="cs-mimi__msg-product" href="/collections/toutes-nos-fleurs"><span class="cs-mimi__msg-product-name">Voir toutes les fleurs</span><span class="cs-mimi__msg-product-meta">Tous les paliers</span></a>';
        }
      },

      /* ============ 7. Conduite / test salivaire (légal critique) ============ */
      {
        match: /\b(conduire|conduit|voiture|salivaire|alcootest|permis|stup[ée]fiant|d[ée]pistage)\b|test (positif|salivaire|d[ée]pistage)/i,
        respond: function () {
          return " Important : nos produits sont <b>&lt; 0,3 % de THC</b> (limite légale FR), mais <b>le THC reste détectable au test salivaire</b> même en infime quantité. Le test mesure la <b>présence</b>, pas l'effet.<br>"
            + "→ Évite de conduire après consommation de fleur/résine.<br>"
            + "→ Si tu conduis tous les jours : nos <b>huiles isolat ou broad-spectrum (0 % THC)</b> sont la solution safe.";
        }
      },

      /* ============ 8. Grossesse / allaitement (renvoi médecin) ============ */
      {
        match: /\b(grossesse|enceinte|allaitement|allaiter|maternit[ée])\b|b[ée]b[ée]/i,
        respond: function () {
          return "On déconseille le CBD pendant la grossesse et l'allaitement. Pas par dogme — il manque encore d'études solides sur le sujet. Le mieux dans cette période : <b>en parler à ta sage-femme ou ton médecin</b>. On ne te conseillera pas mieux qu'eux là-dessus.";
        }
      },

      /* ============ 9. Animaux (renvoi véto) ============ */
      {
        match: /\b(chien|chat|chiot|chaton|v[ée]t[ée]rinaire|cheval|chevaux|animal|animaux)\b/i,
        respond: function () {
          return "Le CBD pour animaux existe, mais ce n'est pas notre métier. Nos produits sont formulés pour les humains (dosages, parfums, supports). Pour ton chien/chat : va voir un véto spécialisé, il dose en mg/kg, c'est plus précis et plus safe.";
        }
      },

      /* ============ 10. Douleur (pas de promesse santé) ============ */
      {
        match: /\b(douleur|douloureu|migraine|articulation|arthrose|rhumatis|inflam)\b|mal (de |au )?(t[ée]te|tete|dos|ventre|nuque|r[èe]gles)/i,
        respond: function () {
          return "Le CBD est utilisé pour ses propriétés relaxantes. Beaucoup de retours sur les douleurs musculaires, articulaires, menstruelles — mais on ne fera <b>aucune promesse médicale</b> (interdit en France). Pour douleur chronique : <b>parle à ton médecin avant</b>.<br>"
            + "Côté produit : huile sublingual matin + soir, ou baume si c'est localisé.";
        }
      },

      /* ============ 11. Anxiété / stress (pas de promesse santé) ============ */
      {
        match: /\b(anxi[ée]t|anxieu|stress|stress[ée]|angoiss|panique|nervosit|burn.?out)\b|nerveux|nerveuse/i,
        respond: function () {
          return "Le CBD est connu pour ses effets relaxants. Beaucoup l'utilisent pour calmer la rumination ou le stress du quotidien. <b>On ne te promet rien</b> (pas de pub santé en France), mais le retour client va très majoritairement dans ce sens.<br>"
            + "Format conseillé : <b>huile sublingual 5-10 mg</b>, le soir ou avant un moment chargé.";
        }
      },

      /* ============ 12. Conservation ============ */
      {
        match: /\b(conserv|stocker|garder au frais|frigo|p[ée]remption|date d'expiration|dur[ée]e de vie)\b/i,
        respond: function () {
          return "Pour préserver le goût et le taux de CBD<br>"
            + "• <b>Fleurs &amp; résines</b> : bocal hermétique, à l'abri de la lumière, 18-22°C → tient 6 mois facile<br>"
            + "• <b>Huiles</b> : frigo après ouverture, position debout → tient 12 mois<br>"
            + "• <b>Loin des enfants et des animaux</b>, toujours.";
        }
      },

      /* ============ 13. Indoor / outdoor / greenhouse ============ */
      {
        match: /\b(indoor|outdoor|greenhouse|sous serre|serre)\b|culture (int[ée]rieur|ext[ée]rieur)|diff[ée]rence (indoor|outdoor)/i,
        respond: function () {
          return "Trois cultures, trois ambiances<br>"
            + "• <b>Indoor</b> : intérieur sous lampes → taux CBD élevé, goût intense, fleur dense. Le plus cher.<br>"
            + "• <b>Greenhouse</b> : serre, lumière naturelle + protection → bon rapport qualité/prix.<br>"
            + "• <b>Outdoor</b> : plein air → plus aromatique, taux modéré, prix doux.<br>"
            + "Pour démarrer : outdoor. Pour la puissance : indoor.";
        }
      },

      /* ============ 14. Différence fleur / résine / huile ============ */
      {
        match: /diff[ée]rence (entre )?(fleur|hash|r[ée]sine|huile)|fleur ou (huile|r[ée]sine|hash)|r[ée]sine ou (fleur|huile|hash)|hash ou (fleur|r[ée]sine|huile)|huile ou (fleur|r[ée]sine|hash)/i,
        respond: function () {
          return "Les 3 formats de base<br>"
            + "• <b>Fleur</b> : la plante séchée, infusion ou inhalation. Spectre complet, effet rapide si inhalé.<br>"
            + "• <b>Résine (hash)</b> : concentré naturel des trichomes. Plus puissant, mêmes usages.<br>"
            + "• <b>Huile</b> : CBD + huile végétale, sublingual. Effet plus long, dosage précis, discret.<br>"
            + "Si tu débutes → <b>huile sublingual</b> (le plus simple à doser).";
        }
      },

      /* ============ 15. Effets ressentis ============ */
      {
        match: /\b(effet|ressent|d[ée]fonce|planer|stoned|high|sensation|d[ée]tend|relaxant|relaxation)\b|ça fait quoi/i,
        respond: function () {
          return "Le CBD c'est de la détente, pas de la défonce. Concrètement : épaules qui se relâchent, respiration qui ralentit, tête qui reste claire. <b>Pas de molécule psychoactive</b> comme le THC. Tu restes toi, juste plus posé.";
        }
      },

      /* ============ 16. Première fois (avant débuter — sinon avalé par "premier") ============ */
      {
        match: /premi[èe]re fois|jamais (essay[ée]|test[ée]|pris)|peur de (planer|d[ée]fonce|m'endormir)|comment [çc]a (fait|va me|me fait|fonctionne)|j'ai jamais/i,
        respond: function () {
          return "Tu vas pas planer. Le CBD ne provoque pas de défonce — c'est <b>l'inverse du THC</b>. Effet typique : apaisement physique léger, souffle qui ralentit, tension qui descend. Tu restes lucide, fonctionnel.<br>"
            + "Dose de départ : <b>5 mg sublingual</b> (1-2 gouttes d'une huile 10 %). Tu attends 1 h. Si rien, tu remontes de +5 mg. <b>Pas besoin d'en mettre plein la première fois.</b>";
        }
      },

      /* ============ 17. Boutique physique (pas d'adresse) ============ */
      {
        match: /\b(boutique|physique|adresse|magasin|local|visiter)\b/i,
        respond: function () { return "On est <b>100 % en ligne</b> pour le moment — nos lots partent de Charente, expédition sous 24 h. Pas de boutique physique pour l'instant."; }
      },

      /* ============ 18. Parrainage ============ */
      {
        match: /\b(parrainer|parrainage|code|pote|ami(s|e|es)?)\b/i,
        respond: function () { switchToTab('rewards'); return "Tu trouveras ton lien de parrainage dans l'onglet <b>Avantages</b>."; }
      },

      /* ============ 19. Avis Trustpilot ============ */
      {
        match: /\b(avis|trustpilot|retour client|note)\b/i,
        respond: function () { return 'Tu peux laisser un avis sur Trustpilot : <a href="' + (data.trustpilotUrl || '#') + '" target="_blank" rel="noopener">noter Cloud Store →</a>'; }
      },

      /* ============ 20. Réseaux sociaux ============ */
      {
        match: /\b(instagram|insta|tiktok|facebook|r[ée]seaux|suivre|social)\b/i,
        respond: function () { switchToTab('social'); return "Onglet <b>Réseaux</b> ouvert — choisis où tu veux nous suivre."; }
      },

      /* ============ 21. CBN / sommeil (réécrit : réponse + lien) ============ */
      {
        match: /\b(cbn|sommeil|dormir|nuit|insomnie|repos|m[ée]latonine|s'endormir|endormir)\b/i,
        respond: function () {
          return "Pour le soir, le combo qui marche le mieux<br>"
            + "• <b>Huile CBD + CBN + Mélatonine</b> en sublingual, 30-45 min avant le coucher (CBN = effet sédatif, mélatonine = endormissement)<br>"
            + "• Ou tisane CBD (effet plus doux, plus long à venir, mais durable)<br>"
            + '<a class="cs-mimi__msg-product" href="/collections/huiles-cbd"><span class="cs-mimi__msg-product-name">Sélection nuit</span><span class="cs-mimi__msg-product-meta">Huiles CBN + Mélatonine</span></a>'
            + '<a class="cs-mimi__msg-product" href="/blogs/guide-cbd/cbd-pour-dormir-dosage-legalite-2026"><span class="cs-mimi__msg-product-name"> Guide complet sommeil</span><span class="cs-mimi__msg-product-meta">Dosage &amp; légalité 2026</span></a>';
        }
      },

      /* ============ 22. Arrêter THC / tabac (réécrit) ============ */
      {
        match: /\b(arr[eê]ter|sevrage|tabac|cigarette|fumer le cannabis|fumer la weed|fumer du thc|remplacer)\b/i,
        respond: function () {
          return "Le CBD aide pas par effet de remplacement direct — il agit sur l'<b>anxiété de manque</b> et le <b>réflexe geste</b>. Concrètement : pré-roulé CBD à la place de la cigarette/joint, huile sublingual aux moments de craving. Programme typique : 2-4 semaines pour changer le geste.<br>"
            + '<a class="cs-mimi__msg-product" href="/blogs/guide-cbd/cbd-arreter-thc-remplacer-tabac"><span class="cs-mimi__msg-product-name"> Guide arrêter THC / tabac</span><span class="cs-mimi__msg-product-meta">Méthode pas à pas</span></a>';
        }
      },

      /* ============ 23. Sport / récupération (réécrit) ============ */
      {
        match: /\b(sport|sportif|sportive|r[ée]cup[ée]ration|courbature|muscle|effort|entra[iî]nement|gym|fitness|musculation)\b/i,
        respond: function () {
          return "Deux usages distincts<br>"
            + "• <b>Avant</b> : focus mental + baisse anxiété de perf (sublingual 30 min avant)<br>"
            + "• <b>Après</b> : récup, baisse courbatures (sublingual + baume sur muscles tendus)<br>"
            + "Évite les fleurs avant un effort cardio (effet vasodilatateur).<br>"
            + '<a class="cs-mimi__msg-product" href="/blogs/guide-cbd/cbd-sport-recuperation-utilisation"><span class="cs-mimi__msg-product-name"> Guide sport &amp; récup</span><span class="cs-mimi__msg-product-meta">Tout y est</span></a>';
        }
      },

      /* ============ 24. Cuisine (réécrit) ============ */
      {
        match: /\b(cuisin|recette|manger|infusion|tisane|space cake|brownie)\b|th[ée] cbd/i,
        respond: function () {
          return "Deux pièges à éviter<br>"
            + "• Le CBD est <b>liposoluble</b> → toujours dans une matière grasse (beurre, huile, lait entier). Dans l'eau pure il sert à rien.<br>"
            + "• <b>Pas au-delà de ~160°C</b> → le CBD se dégrade. Cuisson douce uniquement.<br>"
            + "Idée simple pour tester : tisane lait + 1 g de fleur infusée 15 min.<br>"
            + '<a class="cs-mimi__msg-product" href="/blogs/guide-cbd/cuisiner-cbd-maison"><span class="cs-mimi__msg-product-name"> Recettes maison</span><span class="cs-mimi__msg-product-meta">Astuces &amp; quantités</span></a>';
        }
      },

      /* ============ 25. Spectre full / broad / isolat (réécrit) ============ */
      {
        match: /\b(broad.?spectrum|full.?spectrum|spectre|isolat|isolate)\b|sans thc|0\s?%\s?thc/i,
        respond: function () {
          return "Trois types d'huiles<br>"
            + "• <b>Full-spectrum</b> : CBD + cannabinoïdes mineurs + &lt; 0,3 % THC → effet d'entourage max<br>"
            + "• <b>Broad-spectrum</b> : idem mais <b>0 % THC</b> → safe test salivaire<br>"
            + "• <b>Isolat</b> : CBD pur (&gt;99 %), neutre, dosage hyper précis<br>"
            + "Pour commencer : <b>broad-spectrum</b> (effet entourage sans THC).";
        }
      },

      /* ============ 26. Étiquette / qualité (réécrit) ============ */
      {
        match: /\b([eé]tiquette|label|qualit[ée]|reconna[iî]tre|fiable|s[ée]rieux|analyse|certifi|coa)\b/i,
        respond: function () {
          return "Une bonne huile se reconnaît à 4 trucs<br>"
            + "1. <b>Origine du chanvre</b> mentionnée (UE / France idéalement)<br>"
            + "2. <b>Taux CBD en mg</b> + volume du flacon (pas juste %)<br>"
            + "3. <b>Spectre</b> clair (full / broad / isolat)<br>"
            + "4. <b>Analyse tierce (COA)</b> disponible<br>"
            + "Si l'étiquette dit juste « huile CBD » sans plus → tu fuis.<br>"
            + '<a class="cs-mimi__msg-product" href="/blogs/guide-cbd/comment-lire-etiquette-huile-cbd"><span class="cs-mimi__msg-product-name"> Lire une étiquette d\'huile CBD</span><span class="cs-mimi__msg-product-meta">Décrypter la qualité</span></a>';
        }
      },

      /* ============ 27. Aquaponie / culture (réécrit) ============ */
      {
        match: /\b(aquaponie|aquaponic|hydroponi|cultiv|culture bio|bio)\b|comment.+pousse/i,
        respond: function () {
          return "L'aquaponie c'est <b>chanvre + poissons en circuit fermé</b>. Les déjections poissons fertilisent les plantes, les plantes filtrent l'eau. <b>Pas d'engrais chimique, pas de pesticide</b> (les poissons en mourraient). Résultat : fleur propre, profil aromatique pur, eau économisée. C'est ce qu'utilisent nos fournisseurs FR.<br>"
            + '<a class="cs-mimi__msg-product" href="/blogs/guide-cbd/aquaponie-cbd-comment-ca-marche"><span class="cs-mimi__msg-product-name"> Comment ça marche</span><span class="cs-mimi__msg-product-meta">Notre approche culture</span></a>';
        }
      },

      /* ============ 28. Légalité (réécrit) ============ */
      {
        match: /\b(l[ée]galit[ée]|l[ée]gal|loi|interdit|risques?|d[ée]riv[ée]s|chanvre)\b/i,
        respond: function () {
          return "Cadre légal en France<br>"
            + "• <b>THC &lt; 0,3 %</b> obligatoire (Conseil d'État, 29 déc 2022)<br>"
            + "• <b>CBD libre à la vente</b> sous toutes formes (fleur, résine, huile, infusion)<br>"
            + "• <b>HHC, H4CBD, THCP</b> = synthétiques <b>interdits</b> depuis juin 2023 → on n'en vend pas<br>"
            + "• <b>Pas de pub santé</b> autorisée → c'est pour ça qu'on ne te promet jamais de cure miracle<br>"
            + '<a class="cs-mimi__msg-product" href="/blogs/guide-cbd/derives-chanvre-france-legalite-risques"><span class="cs-mimi__msg-product-name"> Guide légalité complet</span><span class="cs-mimi__msg-product-meta">Cadre &amp; risques</span></a>';
        }
      },

      /* ============ 29. Dosage (réécrit) ============ */
      {
        match: /\b(dosage|posologie|mg)\b|combien (de )?goutt|comment (utiliser|prendre|doser|consommer)/i,
        respond: function () {
          return "Dosage CBD = patience + écoute<br>"
            + "• <b>Démarre bas</b> : 5 mg sublingual (1-2 gouttes d'une huile 10 %) pendant 3-4 jours<br>"
            + "• <b>Évalue</b> 60-90 min après prise<br>"
            + "• <b>Monte de +5 mg</b> si rien<br>"
            + "• Plage utile typique : <b>10 à 50 mg/jour</b> selon le besoin<br>"
            + '<a class="cs-mimi__msg-product" href="/blogs/guide-cbd/huile-cbd-dosage-gouttes-consommation"><span class="cs-mimi__msg-product-name"> Guide dosage complet</span><span class="cs-mimi__msg-product-meta">Gouttes, mg, fréquence</span></a>';
        }
      },

      /* ============ 30. Débuter (large — passe APRÈS "première fois") ============ */
      {
        match: /(d[ée]but|premier|nouveau|d[ée]marrer|commenc|d[ée]couvr|test[eé]|quoi prendre|que prendre|conseil|pack)/i,
        respond: function () {
          return "Pour démarrer, deux entrées simples :<br>"
            + '<a class="cs-mimi__msg-product" href="/collections/packs"><span class="cs-mimi__msg-product-name">Packs Découverte</span><span class="cs-mimi__msg-product-meta">Sélection variée à prix doux</span></a>'
            + '<a class="cs-mimi__msg-product" href="/collections/joints-cbd-pre-roules-fleurs-au-choix-cloud-store"><span class="cs-mimi__msg-product-name">Pré-roulés CBD</span><span class="cs-mimi__msg-product-meta">Fleur au choix, prêts à l\'emploi</span></a>'
            + "Et si tu hésites entre fleur ou huile, dis-le moi — je t'oriente.";
        }
      },

      /* ============ 31. Humain (déclencheur explicite) ============ */
      {
        match: /\b(humain|conseiller|aide|contact|parler [aà])\b/i,
        respond: function () {
          setTimeout(function () { handleInboxOpen(); }, 200);
          return "J'ouvre le chat avec notre équipe humaine (lun-sam 10h-19h).";
        }
      },

      /* ============ 32. Politesse ============ */
      {
        match: /\b(merci|thanks|cool|super|top)\b/i,
        respond: function () { return pickRandom(["De rien ", "Avec plaisir !", "C'est gentil "]); }
      },

      /* ============ 33. Blog (large — passe en dernier) ============ */
      {
        match: /\b(blog|article|guide|en savoir|apprendre|info)\b/i,
        respond: function () {
          return 'Tous nos guides sont sur <a href="/blogs/guide-cbd">notre blog </a> — sommeil, sport, dosage, légalité, cuisine… Tape un mot-clé et je te trouve l\'article !';
        }
      }
    ];

    function processMessage(text) {
      addUserMessage(text);
      window.__csMimi.setMood('pensive');
      var response = null;
      var moodAfter = 'idle';
      for (var i = 0; i < intents.length; i++) {
        if (intents[i].match.test(text)) {
          response = intents[i].respond();
          if (intents[i].mood) moodAfter = intents[i].mood;
          break;
        }
      }
      if (!response) {
        response = "Sur ce point précis je veux pas inventer — reformule avec un mot-clé plus direct (effet, dosage, livraison, prix, légalité…)<br>"
          + "Si c'est urgent, je passe la main à l'équipe humaine :<br>"
          + '<button type="button" class="cs-mimi__inline-human-btn" data-cs-mimi-inbox> Parler à l\'équipe</button>'
          + '<small style="display:block;margin-top:6px;opacity:0.7">lun-sam 10h-19h · ' + (data.contactEmail || 'cloudstorecbd@gmail.com') + '</small>';
      }
      setTimeout(function () {
        addBotMessage(response);
        if (moodAfter === 'idle') {
          window.__csMimi.setMood('idle');
        } else {
          window.__csMimi.setMood(moodAfter, 2000);
        }
      }, 350);
    }

    function addUserMessage(text) {
      var div = document.createElement('div');
      div.className = 'cs-mimi__msg cs-mimi__msg--user';
      div.textContent = text;
      msgContainer.appendChild(div);
      msgContainer.scrollTop = msgContainer.scrollHeight;
      /* Bascule l'état conversationnel : masque l'accueil + les chips (fallback CSS sans :has()) */
      var chatView = root.querySelector('.cs-mimi__view[data-view="chat"]');
      if (chatView) chatView.classList.add('is-chatting');
    }
    function addBotMessage(html) {
      var div = document.createElement('div');
      div.className = 'cs-mimi__msg cs-mimi__msg--bot';
      div.innerHTML = html;
      msgContainer.appendChild(div);
      msgContainer.scrollTop = msgContainer.scrollHeight;
    }
    function switchToTab(target) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-tab') === target;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      views.forEach(function (v) {
        v.classList.toggle('is-active', v.getAttribute('data-view') === target);
      });
    }

    if (form && input) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var text = input.value.trim();
        if (!text) return;
        input.value = '';
        processMessage(text);
      });
    }

    quickActions.forEach(function (btn) {
      btn.addEventListener('click', function () {
        /* data-quick = question complète injectée dans le chat (mode hub).
           Fallback textContent pour rétro-compat avec l'ancien format chip. */
        var dq = btn.getAttribute('data-quick') || '';
        var label = dq.length > 3 ? dq : btn.textContent.replace(/[?]/g, '').trim();
        processMessage(label);
      });
    });

    /* Ouvre Shopify Inbox depuis Mimi.
       Inbox 2026 = custom element <inbox-online-store-chat> avec shadow DOM,
       dont le launcher est button.chat-toggle. Sur les versions plus anciennes
       on a parfois shopify-chat / window.ShopifyChat.open. On essaie plusieurs
       stratégies dans l'ordre, du plus moderne au plus legacy. */
    function openShopifyInbox() {
      /* 1. Custom element moderne — chercher button.chat-toggle dans shadow ou light DOM */
      try {
        var ic = document.querySelector('inbox-online-store-chat');
        if (ic) {
          var btn = null;
          if (ic.shadowRoot) {
            btn = ic.shadowRoot.querySelector('button.chat-toggle, button[class*="chat-toggle"]');
          }
          if (!btn) {
            btn = ic.querySelector && ic.querySelector('button.chat-toggle, button[class*="chat-toggle"]');
          }
          if (btn && typeof btn.click === 'function') { btn.click(); return true; }
        }
      } catch (e) {}
      /* 2. Bouton chat-toggle accessible directement dans le document */
      try {
        var anyBtn = document.querySelector('button.chat-toggle, button[class*="chat-toggle"]');
        if (anyBtn && typeof anyBtn.click === 'function') { anyBtn.click(); return true; }
      } catch (e) {}
      /* 3. État localStorage + storage event (best-effort, marche sur certaines versions React) */
      try {
        var raw = localStorage.getItem('shopifyChatData') || '{}';
        var chatData = JSON.parse(raw);
        chatData.isOpen = true;
        var newRaw = JSON.stringify(chatData);
        localStorage.setItem('shopifyChatData', newRaw);
        if (typeof StorageEvent === 'function') {
          window.dispatchEvent(new StorageEvent('storage', {
            key: 'shopifyChatData',
            oldValue: raw,
            newValue: newRaw,
            storageArea: localStorage
          }));
        }
      } catch (e) {}
      /* 4. APIs legacy (anciennes versions Inbox / autres apps de chat) */
      try {
        if (window.ShopifyChat && typeof window.ShopifyChat.open === 'function') {
          window.ShopifyChat.open(); return true;
        }
        if (window.shopifyInbox && typeof window.shopifyInbox.open === 'function') {
          window.shopifyInbox.open(); return true;
        }
        if (typeof window.reattachChatWidget === 'function') {
          window.reattachChatWidget(); return true;
        }
        var legacy = document.querySelector('shopify-chat, [data-shopify-chat], #ShopifyChatWidget');
        if (legacy && typeof legacy.click === 'function') { legacy.click(); return true; }
      } catch (e) {}
      return false;
    }

    function handleInboxOpen() {
      /* Si le widget Inbox est déjà mounté (chargé par une session précédente
         ou un autre clic), on essaie d'ouvrir directement. */
      if (document.querySelector('inbox-online-store-chat')) {
        var opened = openShopifyInbox();
        if (opened) {
          if (panel && !panel.hasAttribute('hidden')) closePanel();
        } else {
          window.location.href = 'mailto:' + (data.contactEmail || 'cloudstorecbd@gmail.com');
        }
        return;
      }

      /* Sinon : lazy-load via window.csLoadInbox (défini dans cs-inbox-lazy.liquid),
         puis ouvre. ~265 KB de JS chargés à ce moment précis seulement. */
      if (typeof window.csLoadInbox !== 'function') {
        /* Fallback : pas de lazy-loader → email direct */
        window.location.href = 'mailto:' + (data.contactEmail || 'cloudstorecbd@gmail.com');
        return;
      }

      /* Indicateur visuel pendant le chargement (~1-2s) */
      var btn = panel && panel.querySelector('[data-cs-mimi-inbox]');
      var origText = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Ouverture du chat…'; btn.disabled = true; }

      window.csLoadInbox().then(function () {
        if (btn) { btn.textContent = origText; btn.disabled = false; }
        /* Retry quelques fois car React peut ne pas avoir totalement mount le button */
        var tries = 0;
        var iv = setInterval(function () {
          if (openShopifyInbox()) {
            clearInterval(iv);
            if (panel && !panel.hasAttribute('hidden')) closePanel();
          } else if (++tries > 30) {
            clearInterval(iv);
            window.location.href = 'mailto:' + (data.contactEmail || 'cloudstorecbd@gmail.com');
          }
        }, 100);
      }).catch(function () {
        if (btn) { btn.textContent = origText; btn.disabled = false; }
        window.location.href = 'mailto:' + (data.contactEmail || 'cloudstorecbd@gmail.com');
      });
    }

    /* Délégation : tout bouton [data-cs-mimi-inbox] dans le panneau (statique
       sous le chat OU injecté dynamiquement dans un message bot fallback)
       déclenche l'ouverture Inbox via handleInboxOpen. */
    panel.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-cs-mimi-inbox]');
      if (t) handleInboxOpen();
    });

    /* Map nos noms internes vers les deep-links Smile officiels */
    var SMILE_DEEPLINKS = {
      rewards: 'points_products',
      referrals: 'referral_program',
      referral: 'referral_program'
    };

    function openSmileNow(deepLink) {
      try {
        if (window.SmileUI && typeof window.SmileUI.openPanel === 'function') {
          /* Ferme Mimi pour libérer la zone bas-droite avant l'ouverture de Smile */
          if (panel && !panel.hasAttribute('hidden')) closePanel();
          window.SmileUI.openPanel(deepLink ? { deep_link: deepLink } : undefined);
          return true;
        }
      } catch (e) {}
      return false;
    }

    /* Polling jusqu'à 8s : Smile UI est injecté en différé (window.load + async),
       donc un clic au tout début de la session arrive avant que SmileUI soit prêt. */
    function tryOpenSmile(panelName) {
      var deepLink = SMILE_DEEPLINKS[panelName] || null;
      if (openSmileNow(deepLink)) return;

      /* Feedback discret pendant l'attente */
      var bubble = window.__csMimi.showCloud
        ? window.__csMimi.showCloud("Je charge le programme fidélité… ", { duration: 0, dismissible: false })
        : null;

      var attempts = 0;
      var maxAttempts = 40; /* 40 × 200ms = 8s */
      var iv = setInterval(function () {
        attempts++;
        if (openSmileNow(deepLink)) {
          clearInterval(iv);
          if (bubble) {
            bubble.classList.remove('is-visible');
            setTimeout(function () { if (bubble.parentNode) bubble.parentNode.removeChild(bubble); }, 350);
          }
          return;
        }
        if (attempts >= maxAttempts) {
          clearInterval(iv);
          if (bubble) {
            bubble.classList.remove('is-visible');
            setTimeout(function () { if (bubble.parentNode) bubble.parentNode.removeChild(bubble); }, 350);
          }
          /* Fallback : recharger la page avec le query param Smile (auto-open au load) */
          if (deepLink) {
            try {
              var url = new URL(window.location.href);
              url.searchParams.set('smile_deep_link', deepLink);
              window.location.href = url.toString();
              return;
            } catch (e) {}
          }
          if (window.__csMimi.showCloud) {
            window.__csMimi.showCloud("Le programme met du temps à se charger — recharge la page si rien ne s'ouvre.", { duration: 6000 });
          }
        }
      }, 200);
    }

    if (smileRewardsBtn) {
      smileRewardsBtn.addEventListener('click', function () { tryOpenSmile('rewards'); });
    }
    if (smileReferralBtn) {
      smileReferralBtn.addEventListener('click', function () { tryOpenSmile('referrals'); });
    }

    function setupProductBubble() {
      if (!data.isProduct) return;
      var btn = document.querySelector('[data-cs-mimi-trigger]');
      if (!btn) return;

      var bubble = document.querySelector('[data-cs-mimi-bubble]');
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cs-mimi-bubble';
        bubble.setAttribute('data-cs-mimi-bubble', '');
        btn.appendChild(bubble);
      }

      var msg;
      if (data.altProduct && data.altProduct.title && data.altProduct.url) {
        msg = 'Mimi est là si tu hésites entre <b>' + data.productTitle + '</b> et <a href="' + data.altProduct.url + '" style="color:inherit;text-decoration:underline">' + data.altProduct.title + '</a> ';
      } else {
        msg = 'Mimi est là si tu hésites ';
      }
      bubble.innerHTML = msg;

      /* Mobile : auto-show 4s après chargement (le hover n'existe pas) */
      if (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) {
        setTimeout(function () { bubble.classList.add('is-visible'); }, 600);
        setTimeout(function () { bubble.classList.remove('is-visible'); }, 4600);
        return;
      }

      var buy = document.querySelector('.cs-pdp__buy');
      if (!buy || !('IntersectionObserver' in window)) {
        bubble.classList.add('is-visible');
        setTimeout(function () { bubble.classList.remove('is-visible'); }, 8000);
        return;
      }

      var shown = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !shown) {
            shown = true;
            bubble.classList.add('is-visible');
            setTimeout(function () { bubble.classList.remove('is-visible'); }, 8000);
          }
        });
      }, { threshold: 0.4 });
      io.observe(buy);
    }
    setupProductBubble();

    /* ============ Bulles pop-up "nuage" au-dessus de Mimi ============
       Système réutilisable : showCloud(html, { duration, dismissible }).
       À la 1ʳᵉ visite (sessionStorage) : bulle de bienvenue + mood "ravi".
       Aucune ouverture forcée du panneau. */
    var cloudStack = root.querySelector('[data-cs-mimi-cloud-stack]');
    function clearClouds() {
      if (!cloudStack) return;
      var existing = cloudStack.querySelectorAll('.cs-mimi__cloud');
      existing.forEach(function (b) { hideCloud(b); });
    }
    function showCloud(html, opts) {
      if (!cloudStack) return null;
      opts = opts || {};
      var duration = typeof opts.duration === 'number' ? opts.duration : 7000;
      var dismissible = opts.dismissible !== false;
      /* Toujours fermer la bulle précédente avant d'en montrer une nouvelle */
      clearClouds();
      var bubble = document.createElement('div');
      bubble.className = 'cs-mimi__cloud';
      bubble.innerHTML = html;
      if (dismissible) {
        var close = document.createElement('button');
        close.type = 'button';
        close.className = 'cs-mimi__cloud-close';
        close.setAttribute('aria-label', 'Fermer');
        close.textContent = '×';
        close.addEventListener('click', function () { hideCloud(bubble); });
        bubble.appendChild(close);
      }
      /* Petit délai pour laisser la bulle précédente terminer son fade-out (~350ms) */
      setTimeout(function () {
        cloudStack.appendChild(bubble);
        requestAnimationFrame(function () { bubble.classList.add('is-visible'); });
        if (duration > 0) {
          setTimeout(function () { hideCloud(bubble); }, duration);
        }
      }, 360);
      return bubble;
    }
    function hideCloud(bubble) {
      if (!bubble || !bubble.parentNode) return;
      bubble.classList.remove('is-visible');
      setTimeout(function () { if (bubble.parentNode) bubble.parentNode.removeChild(bubble); }, 350);
    }
    window.__csMimi.showCloud = showCloud;
    window.__csMimi.clearClouds = clearClouds;

    /* ============ Détection arrivée via blog (article ou liste) ============
       True ssi : (1) la page actuelle est un article ou la liste blog, ET
       (2) le referrer n'est pas le même hôte (Google, lien partagé, direct…).
       But : afficher un popup différent et complice quand un visiteur SEO/social
       atterrit sur un guide, sans flooder ceux qui arrivent par la home. */
    function isBlogArrival() {
      var t = data.template ? String(data.template) : '';
      var onBlogContent = t.indexOf('article') === 0 || t === 'blog';
      if (!onBlogContent) return false;
      var ref = document.referrer || '';
      if (!ref) return true; /* direct ou navigation privée → considéré externe */
      try {
        var refHost = new URL(ref).hostname;
        if (refHost && refHost === window.location.hostname) return false;
      } catch (e) {}
      return true;
    }

    try {
      if (sessionStorage.getItem('cs-mimi-seen')) {
        if (notif) notif.classList.add('is-hidden');
      } else {
        sessionStorage.setItem('cs-mimi-seen', '1');

        if (isBlogArrival()) {
          /* === Flux "arrivée blog" : 1 seule bulle, complice, anti-flooding ===
             Garde-fous : (a) délai 2,5 s pour laisser charger la page, (b) skip
             si user a déjà ouvert Mimi avant le timer, (c) skip si user a déjà
             scrollé > 600px (il lit, on n'interrompt pas), (d) une seule bulle
             (pas de stack maintenance), (e) flag "cs-mimi-seen" partagé donc
             jamais combiné avec le welcome standard. */
          var blogTimer = setTimeout(function () {
            blogTimer = null;
            var alreadyOpen = panel && !panel.hasAttribute('hidden');
            if (alreadyOpen) return;
            if ((window.scrollY || window.pageYOffset || 0) > 600) return;
            showCloud(
              "Eh, t'arrives par un de nos articles — t'es du genre à lire avant d'acheter, j'aime ça. Une question pendant ta lecture ? <b>Clique-moi.</b>",
              { duration: 7500 }
            );
            window.__csMimi.setMood('ravi', 3500);
          }, 2500);

          var cancelBlogPopup = function () {
            if (blogTimer) { clearTimeout(blogTimer); blogTimer = null; }
            document.removeEventListener('scroll', onBlogScroll);
            if (trigger) trigger.removeEventListener('click', cancelBlogPopup);
          };
          var onBlogScroll = function () {
            if ((window.scrollY || window.pageYOffset || 0) > 600) cancelBlogPopup();
          };
          document.addEventListener('scroll', onBlogScroll, { passive: true });
          if (trigger) trigger.addEventListener('click', cancelBlogPopup);
        } else {
          /* === Flux par défaut (welcome) === */
          setTimeout(function () {
            showCloud("Bienvenue chez <b>Cloud Store</b> — moi c'est <b>Mimi</b>, ravie de t'accueillir !", { duration: 6500 });
            window.__csMimi.setMood('ravi', 4500);
          }, 1200);
        }
      }
    } catch (e) {}

    /* ============ Yeux qui suivent le curseur ============ */
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var svg = root.querySelector('.cs-mimi__img svg');
    var leftIrises = svg ? svg.querySelectorAll('.cs-mimi-iris--l') : [];
    var rightIrises = svg ? svg.querySelectorAll('.cs-mimi-iris--r') : [];
    if (svg && leftIrises.length && rightIrises.length && !prefersReducedMotion) {
      var rafId = null;
      var pendingMouse = { x: 0, y: 0 };
      var avatarEl = trigger;

      function updateGaze() {
        rafId = null;
        var rect = avatarEl.getBoundingClientRect();
        var cx = rect.left + rect.width / 2;
        var cy = rect.top + rect.height / 2;
        var dx = pendingMouse.x - cx;
        var dy = pendingMouse.y - cy;
        var dist = Math.sqrt(dx * dx + dy * dy);
        if (dist === 0) return;
        /* Range : ~1.4px de translation max (en unités SVG, pas px de l'écran) */
        var maxRange = 1.5;
        var nx = (dx / dist) * Math.min(maxRange, dist / 200);
        var ny = (dy / dist) * Math.min(maxRange, dist / 200);
        var nxStr = nx.toFixed(2) + 'px';
        var nyStr = ny.toFixed(2) + 'px';
        leftIrises.forEach(function (el) {
          el.style.setProperty('--iris-x', nxStr);
          el.style.setProperty('--iris-y', nyStr);
        });
        rightIrises.forEach(function (el) {
          el.style.setProperty('--iris-x', nxStr);
          el.style.setProperty('--iris-y', nyStr);
        });
      }

      document.addEventListener('mousemove', function (e) {
        pendingMouse.x = e.clientX;
        pendingMouse.y = e.clientY;
        if (rafId === null) rafId = requestAnimationFrame(updateGaze);
      }, { passive: true });
    }

    /* ============ Idle timer : 30s sans interaction → endormie ============ */
    var idleTimer = null;
    function resetIdleTimer() {
      if (idleTimer) clearTimeout(idleTimer);
      var current = root.getAttribute('data-mood');
      if (current === 'endormie') {
        window.__csMimi.setMood('idle');
      }
      idleTimer = setTimeout(function () {
        if (root.getAttribute('data-mood') === 'idle') {
          window.__csMimi.setMood('endormie');
        }
      }, 30000);
    }
    ['mousemove', 'scroll', 'keydown', 'touchstart'].forEach(function (evt) {
      document.addEventListener(evt, resetIdleTimer, { passive: true });
    });
    /* Pause idle timer when tab hidden — don't fall asleep in background */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        if (idleTimer) { clearTimeout(idleTimer); idleTimer = null; }
      } else {
        resetIdleTimer();
      }
    });
    resetIdleTimer();

    /* ============ Triggers Ravi (cart, Smile points) ============ */
    document.addEventListener('cart:add-success', function () {
      window.__csMimi.setMood('ravi', 3000);
    });
    document.addEventListener('cart:added', function () {
      window.__csMimi.setMood('ravi', 3000);
    });
    window.addEventListener('smile-points-earned', function () {
      window.__csMimi.setMood('ravi', 3000);
    });

    /* ============ Mood "lectrice" — visiteur lit un blog ============
       Sur template article uniquement : si l'utilisateur a scrollé 20%+ et reste
       calme ~8s, Mimi met ses lunettes et fait semblant de lire. Tout clic, gros
       scroll ou ouverture du panneau la ramène en idle. */
    (function setupReadingMood() {
      if (data.template !== 'article') return;
      if (prefersReducedMotion) return;

      var DWELL_BEFORE_READ = 8000;     // ms sur la page avant de basculer
      var IDLE_BEFORE_READ = 3500;      // ms sans interaction rapide
      var SCROLL_PCT_MIN = 0.20;        // 20% de la page parcourue
      var BIG_SCROLL_DELTA = 220;       // px en un tick → user "saute", pas lit
      var TICK_MS = 1000;

      // firstSeen aligné sur DOMContentLoaded (pas le moment d'init) — sinon le lazy-init
      // décale le compteur dwell de 1-3s sur mobile et empêche reading mode d'apparaître
      // dans une session courte (~30s, typique blog mobile).
      var firstSeen = window.__csMimiPageReadyAt || Date.now();
      var lastInteractionAt = Date.now();
      var lastScrollY = window.scrollY || 0;
      var inReading = false;

      function exitReading() {
        if (!inReading) return;
        inReading = false;
        if (root.getAttribute('data-mood') === 'lectrice') {
          window.__csMimi.setMood('idle');
        }
      }

      function tryEnterReading() {
        if (inReading) return;
        if (panel && !panel.hidden) return; /* panneau ouvert → pas de lecture */
        if (root.getAttribute('data-mood') !== 'idle') return;
        var now = Date.now();
        if (now - firstSeen < DWELL_BEFORE_READ) return;
        if (now - lastInteractionAt < IDLE_BEFORE_READ) return;
        var docH = document.documentElement.scrollHeight - window.innerHeight;
        var pct = docH > 0 ? (window.scrollY || 0) / docH : 0;
        if (pct < SCROLL_PCT_MIN) return;
        inReading = true;
        window.__csMimi.setMood('lectrice');
      }

      /* Interactions "rapides" → sortie immédiate + reset compteur idle */
      ['mousedown', 'click', 'keydown', 'touchstart'].forEach(function (evt) {
        document.addEventListener(evt, function () {
          lastInteractionAt = Date.now();
          exitReading();
        }, { passive: true });
      });

      /* Scroll : petit scroll = lecture continue, gros saut = sortie */
      document.addEventListener('scroll', function () {
        var y = window.scrollY || 0;
        var delta = Math.abs(y - lastScrollY);
        lastScrollY = y;
        if (delta > BIG_SCROLL_DELTA) {
          lastInteractionAt = Date.now();
          exitReading();
        }
      }, { passive: true });

      /* Ouverture du panneau Mimi → sortie nette */
      if (trigger) {
        trigger.addEventListener('click', exitReading);
      }

      /* Onglet caché → on remet à zéro le compteur de présence */
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          exitReading();
        } else {
          firstSeen = Date.now();
          lastInteractionAt = Date.now();
        }
      });

      setInterval(tryEnterReading, TICK_MS);
    })();

    /* ============ Intégration Smile.js (balance points + lien parrainage) ============
       SDK chargé async via cs-mimi.liquid (sdk.smile.io/smile-js/v1/smile.js).
       Si client identifié → balance & lien parrainage live. Sinon → fallback discret.
       Indépendant de l'app Smile.io Shopify (qui injecte sa propre UI panel). */
    var REDEEM_RATIO = 20; // 20 pts = 1 €
    var REDEEM_THRESHOLD = 200; // jauge "prochaine récompense" (équivalent 10 €)
    var smileBalanceEl = root.querySelector('[data-cs-mimi-smile-balance]');
    var smilePointsEl = root.querySelector('[data-cs-mimi-smile-points]');
    var smileEurEl = root.querySelector('[data-cs-mimi-smile-eur]');
    var smileBarEl = root.querySelector('[data-cs-mimi-smile-bar]');
    var smileNextEl = root.querySelector('[data-cs-mimi-smile-next]');
    var smileLoginHint = root.querySelector('[data-cs-mimi-smile-loginhint]');
    var smileRefBlock = root.querySelector('[data-cs-mimi-smile-referral-block]');
    var smileRefInput = root.querySelector('[data-cs-mimi-smile-referral-input]');
    var smileRefCopy = root.querySelector('[data-cs-mimi-smile-referral-copy]');
    var smileRefFeedback = root.querySelector('[data-cs-mimi-smile-referral-feedback]');
    var smileRefLoginHint = root.querySelector('[data-cs-mimi-smile-referral-loginhint]');

    function renderSmileBalance(points) {
      if (!smileBalanceEl) return;
      var p = parseInt(points, 10) || 0;
      var eur = (p / REDEEM_RATIO).toFixed(2).replace('.', ',');
      smileBalanceEl.removeAttribute('hidden');
      smileBalanceEl.classList.remove('is-loading');
      if (smilePointsEl) smilePointsEl.textContent = p;
      if (smileEurEl) smileEurEl.textContent = eur;
      if (smileBarEl) {
        var pct = Math.min(100, Math.round((p / REDEEM_THRESHOLD) * 100));
        smileBarEl.style.width = pct + '%';
      }
      if (smileNextEl) {
        var remaining = Math.max(0, REDEEM_THRESHOLD - p);
        if (remaining === 0) {
          smileNextEl.innerHTML = ' Tu peux échanger <b>10 €</b> de réduction !';
        } else {
          smileNextEl.innerHTML = 'Plus que <b>' + remaining + '</b> pts pour <b>10 €</b> de réduction.';
        }
      }
      if (smileLoginHint) smileLoginHint.style.display = 'none';
    }

    function renderSmileReferral(url) {
      if (!smileRefBlock || !url) return;
      smileRefBlock.removeAttribute('hidden');
      if (smileRefInput) smileRefInput.value = url;
      if (smileRefLoginHint) smileRefLoginHint.style.display = 'none';
    }

    if (smileRefCopy && smileRefInput) {
      smileRefCopy.addEventListener('click', function () {
        if (!smileRefInput.value) return;
        var done = function () {
          if (smileRefFeedback) {
            smileRefFeedback.textContent = ' Lien copié !';
            setTimeout(function () { if (smileRefFeedback) smileRefFeedback.textContent = ''; }, 2500);
          }
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(smileRefInput.value).then(done, function () {
            smileRefInput.select(); document.execCommand('copy'); done();
          });
        } else {
          smileRefInput.select(); document.execCommand('copy'); done();
        }
      });
    }

    function bootSmile() {
      try {
        if (typeof window.Smile === 'undefined' || typeof window.Smile.initialize !== 'function') return;
        if (!data.smileChannelKey) return;
        if (window.__csMimiSmileInit) return;
        window.__csMimiSmileInit = true;

        window.Smile.initialize({
          publishableKey: data.smileChannelKey,
          preload: ['pointsSettings']
        }).catch(function () { /* silencieux */ });

        document.addEventListener('smile-js-initialized', function () {
          /* Balance points */
          if (window.Smile.customerPointsWallet && typeof window.Smile.customerPointsWallet.get === 'function') {
            window.Smile.customerPointsWallet.get().then(function (wallet) {
              if (wallet && typeof wallet.pointsBalance !== 'undefined') {
                renderSmileBalance(wallet.pointsBalance);
              } else if (typeof wallet === 'number') {
                renderSmileBalance(wallet);
              }
            }).catch(function () { /* client non identifié → reste sur l'état "Connecte-toi" */ });
          }
          /* Customer info (référral URL) — current() peut retourner null si client non
             logué, donc on guard avant d'appeler.then() */
          if (window.Smile.customer && typeof window.Smile.customer.current === 'function') {
            try {
              var custPromise = window.Smile.customer.current();
              if (custPromise && typeof custPromise.then === 'function') {
                custPromise.then(function (cust) {
                  if (cust && cust.referralUrl) renderSmileReferral(cust.referralUrl);
                }).catch(function () {});
              }
            } catch (e) {}
          }
        });
      } catch (e) {}
    }

    if (typeof window.Smile !== 'undefined') {
      bootSmile();
    } else {
      document.addEventListener('smile-js-loaded', bootSmile);
      /* Sécurité : retry après 2s si l'event a été manqué */
      setTimeout(bootSmile, 2000);
    }

    /* ============ Trigger Surprise (Inbox new message — best effort) ============ */
    setTimeout(function () {
      var chatFrame = document.querySelector('iframe[name="ShopifyChat"]');
      if (!chatFrame || !chatFrame.parentNode) return;
      var seen = false;
      var inboxObserver = new MutationObserver(function () {
        if (seen) return;
        seen = true;
        window.__csMimi.setMood('surprise', 2000);
      });
      inboxObserver.observe(chatFrame.parentNode, { childList: true, subtree: true, attributes: true });
    }, 5000);
  }; // close mainInit
})();
